<template>
  <div id="text">

    <article class="message">
      <div class="message-body">
        <div class="title is-5">Bar Chart</div>
        <div class="text">This bar chart shows the aggregate of methods (scaled 1-5, from transparent to opaque); aesthetics, or language/visuals used (scaled 1-5, from impartial to sensational), and pragmatics, or sphere of impact (scaled 1-5, from public to private), across a sample of investigations between 2004 and 2019.</div>
        <div class="text">This chart allows the viewer to better explore how the nature of British investigative journalism may have changed in discrete phases, across time.</div>
        <div class="text">It is proposed that interactive text boxes containing the details of each investigation will arise in mouse-over, and that further interactive materials (including bespoke videos and learning materials, concerning a top 10 canon in the field) may be made available.</div>
      </div>
    </article>

    <div id="combined-chart">
        <GChart
          :settings="{ packages: ['corechart', 'bar']}"
                type="ColumnChart"
                :data="chartData"
                :options="chartOptions"
                style="width: 1200px; height: 600px;"
                @ready="onChartReady"
                ref="gChart"
        />
    </div>

    <div class="content">
      <strong>Variables:</strong>
      <ul>
        <li>Methods used (scaled 1-5; from transparent to opaque)</li>
        <li>Pragmatics involved (scaled 1-5; from public to private)</li>
        <li>Aesthetics (scaled 1-5; from impartial to sensational)</li>
      </ul>
    </div>

  </div>
</template>

<script>

    import { GChart } from "vue-google-charts";
    import  { dataService } from "../services/data.service";

    export default {
        name: "BarChart",
        props: {
        mydata : []
        },
        components: {
            GChart
        },
        data() {
            return {
                chartData: this.mydata,
                chartOptions: {
                    chart: {
                        title: ''
                    },
                    hAxis: {
                        title: 'Events',
                        minValue: 0,
                    },
                    vAxis: {
                        title: 'Variables'
                    },
                    colors: ['#D6F1FF','#9ae2ff', '#42C0FB'],
                    width: 1200,
                    height: 600,
                    date: '',
                    method: '',
                    pragmatics: '',
                    aethetics: ''
                },
            }
        },
        methods: {
            onChartReady(chart, google) {
                // now we have google lib loaded. Let's create data table based using it.
                this.createDataTable(chart, google);
            },
            // Array will be automatically processed with visualization.arrayToDataTable function
            createDataTable(chart, google) {

                var data = new google.visualization.DataTable();
                data.addColumn('string', 'Year');
                data.addColumn('number', 'Method');
                data.addColumn('number', 'Pragmatics');
                data.addColumn('number', 'Aesthetics');

                let rows = dataService.aggregateData(this.chartData);

                // remove the last element of each row (gatekeeping/impact)
                for(let index in rows) {
                  if(rows.hasOwnProperty(index)){
                    rows[index].pop();
                  }
                }
                data.addRows(rows);

                var view = new google.visualization.DataView(data);
                  chart.draw(view, this.chartOptions);
            },

        }
    }
</script>

<style scoped>

  #combined-chart{
    width: 1200px;
    height: 600px;
  }

  #text {
    width: 100%;
  }

  .text {
    padding: 5px 0;
    width: 100%;
  }

  em {
    font-weight: 500
  }

</style>
